export var slide = 'mb-14 flex justify-center items-center';
export var swiperContainer = 'py-3';
export var card = 'bg-adminPortalBg rounded-2xl text-black max-w-27';
export var imageWrapperWithNoText = 'h-360px md:h-full w-full my-8 bg-adminPortalBg';
export var cardBanner = 'h-full w-full rounded-t-lg object-cover';
export var cardTitle = 'mt-4 text-textDark text-left text-2xl font-bold';
export var cardText = 'text-textMid text-left text-base';
export var statusChip = 'mt-4 mb-1.5';
export var cardInformation = 'bg-uiBg px-4 pb-5 flex flex-col justify-start items-start overflow-visible mb-5';
var dot = 'h-2.5 inline-block rounded-full m-2';
export var paginationItem = "".concat(dot, " w-2.5 bg-secondaryAccent2");
export var activePaginationItem = "".concat(dot, " w-5 bg-secondary");
export var imageWrapper = 'relative h-360px md:h-96 w-full';
export var imageOverlayText = 'absolute bottom-0 left-0 right-0 text-white text-xs px-4 py-2 bg-gradient-to-t from-black/60 to-transparent text-left';
//# sourceMappingURL=header-slider.styles.js.map